import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons';

import SidebarSearch from 'components/search_sidebar/sidebar_search';

import Users from './users';

export default function AvailableUsers({
  selectedUserIds,
  users: allUsers,
  onChange
}) {
  const availableUsers = () => {
    return allUsers.filter(user => selectedUserIds.indexOf(user.id) === -1);
  };

  const [searchText, setSearchText] = useState('');
  const [users, setUsers] = useState(availableUsers());

  React.useEffect(() => {
    setUsers(availableUsers());
  }, [selectedUserIds]);

  const handleSelect = (user) => {
    onChange([...selectedUserIds, user.id]);
  };

  const handleSelectAll = () => {
    onChange(allUsers.map(user => user.id));
  };

  const filteredUsers = () => {
    return users.filter((user) => {
      return !searchText || user.name.toLowerCase().includes(searchText.toLowerCase());
    });
  };

  return (
    <div className="available-users panel panel-default">
      <div className="panel-heading">
        <div className="search-bar">
          <SidebarSearch
            placeholder="Search by name"
            value={searchText}
            onChange={({ target: { value } }) => setSearchText(value)}
          />
        </div>
        <a className="pull-right" name="select-all" onClick={handleSelectAll}>Add All</a>
      </div>

      <Users
        controlIcon={faPlusCircle}
        emptyMessage="All users selected"
        users={filteredUsers()}
        onSelect={handleSelect}
      />
    </div>
  );
}

AvailableUsers.propTypes = {
  selectedUserIds: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,

  onChange: PropTypes.func.isRequired
};
